import * as Yup from 'yup';
import { getPasswordPolicyViolationDetail } from './passwordPolicy';

/** Yup string field matching backend `hash_password` rules. */
export function newPasswordYupString(requiredMessage: string) {
  return Yup.string()
    .required(requiredMessage)
    .test('password-policy', '', function (value) {
      if (!value) {
        return true;
      }
      const detail = getPasswordPolicyViolationDetail(value);
      if (detail) {
        return this.createError({ message: detail });
      }
      return true;
    });
}
